export interface CorporateOnboardingRecordSearchDto {
  searchTerm?: string | null;
  submittedFrom?: string | null; // DateTime as ISO string
  submittedTo?: string | null; // DateTime as ISO string
  pageNumber?: number; // Default: 1
  pageSize?: number; // Default: 10
}
